import axios from 'axios'
import store from '@/store'
import env from '../config/constants'

class ApiService {
  constructor() {
    this.baseURL = env.apiUrl
  }

  signIn(email, password) {
    return this._performRequest('post', 'auth/local', { email, password })
  }

  signUp(credentials) {
    return this._performRequest('post', 'signup', credentials)
  }

  sendForgot(credentials) {
    return this._performRequest('post', 'users/forgot-password', credentials)
  }

  newPassword(newPassword) {
    return this._performRequest('post', 'users/new-password', newPassword)
  }

  changeRole(roleId) {
    return this._performRequest('put', 'users/me/roles/change-role/' + roleId, {})
  }

  getMe(accessToken) {
    return this._performRequest('get', 'users/me', null, accessToken)
  }

  getProfile(type, profileId) {
    return this._performRequest('get', type + '/me/' + profileId)
  }

  updateProfile(type, profileId, data) {
    return this._performRequest('put', type + '/me/' + profileId, data)
  }

  changeProfileImg(type, profileId, data) {
    const formData = new FormData()
    formData.append('profileId', profileId)
    formData.append('profileType', type)
    formData.append('imgType', 'jpeg')
    formData.append('file', data)

    return axios.post(type + '/' + profileId + '/img', formData, {
      baseURL: this.baseURL,
      headers: {
        'x-access-token': store.state.user.token
      }
    })
  }

  changeCoverImg(type, profileId, data) {
    const formData = new FormData()
    formData.append('profileId', profileId)
    formData.append('profileType', type)
    formData.append('imgType', 'jpeg')
    formData.append('file', data)

    return axios.post(type + '/' + profileId + '/cover-img', formData, {
      baseURL: this.baseURL,
      headers: {
        'x-access-token': store.state.user.token
      }
    })
  }

  getRefNpo(refNpo) {
    return this._performRequest('get', '/merchants/me/npo')
  }

  changeRefNpo(refNpo) {
    return this._performRequest('post', '/merchants/me/npo', { refNpo })
  }

  getRoles() {
    return this._performRequest('get', '/users/me/roles')
  }

  getPayments(filters) {
    return this._performRequest('get', 'payments', filters)
  }

  getPayment(id) {
    return this._performRequest('get', 'payments/' + id)
  }

  getAnalytics(userType, filters) {
    return this._performRequest('get', '/' + userType + '-dashboard', filters)
  }

  getDonationFees(filters) {
    return this._performRequest('get', '/donation-fees', filters)
  }

  getDonationFee(id) {
    return this._performRequest('get', '/donation-fees/' + id)
  }

  payDonationFee(feeId, data) {
    return this._performRequest('put', '/donation-fees/' + feeId, data)
  }

  getDonations(filters) {
    return this._performRequest('get', '/donations-npos', filters)
  }

  getDonation(id, filters) {
    return this._performRequest('get', '/donations-npos/' + id, filters)
  }

  getNpos(filters) {
    return this._performRequest('get', '/npos', filters)
  }

  saveCard(merchantId, token, card) {
    const body = {
      token,
      cardHolder: card.name,
      lastDigits: card.last4,
      brand: card.brand,
      expMonth: card.exp_month,
      expYear: card.exp_year
    }
    return this._performRequest('put', '/merchants/me/' + merchantId + '/donation-fees/card', body)
  }

  saveIban(merchantId, source) {
    const body = {
      token: source.id,
      email: source.owner.email,
      accountHolder: source.owner.name,
      sepa: source.sepa_debit
    }
    return this._performRequest('put', '/merchants/me/' + merchantId + '/donation-fees/iban', body)
  }

  setDefaultPaymentMethod(merchantId, method) {
    return this._performRequest('put', '/merchants/me/' + merchantId + '/donation-fees', { method })
  }

  getDonappFees(filters) {
    return this._performRequest('get', '/donapp-fees', filters)
  }

  getPosDevices(filters) {
    return this._performRequest('get', '/merchants/me/pos-devices', filters)
  }

  getRefMerchants(filters) {
    return this._performRequest('get', '/npos/me/affiliate-merchants/', filters)
  }

  sendHelpMessage(data, type) {
    return this._performRequest('post', '/' + type + '/help', data)
  }

  _performRequest(method, url, params, refreshToken) {
    const body = method === 'get' ? 'params' : 'data'
    const config = {
      method,
      url,
      baseURL: this.baseURL,
      [body]: params || {}
    }

    if (refreshToken || (store.state.user && store.state.user.token)) {
      config.headers = {
        'x-access-token': store.state.user.token || refreshToken
      }
    }

    return axios.request(config)
  }
}

export default new ApiService()



// WEBPACK FOOTER //
// ./src/services/ApiService.js